import { AvailableLanguage } from "../utils/translationHelpers";

export interface TranslationSeedItem {
  key: string;
  module?: string | null;
  values: {
    en?: string;
    ru?: string;
    uk?: string;
  };
}

export const TRANSLATIONS_SEED: TranslationSeedItem[] = [
  // NAVIGATION
  {
    key: "form",
    module: null,
    values: {
      en: "Form",
      ru: "Форма",
      uk: "Форма",
    },
  },
  {
    key: "table",
    module: null,
    values: {
      en: "Table",
      ru: "Таблица",
      uk: "Таблиця",
    },
  },
  {
    key: "axiome balance",
    module: null,
    values: {
      en: "Axiome Balance",
      ru: "Axiome Balance",
      uk: "Axiome Balance",
    },
  },
  {
    key: "deliveryExcelColumns",
    module: null,
    values: {
      en: "Delivery Excel columns",
      ru: "Колонки Excel для Delivery",
      uk: "Колонки Excel для Delivery",
    },
  },
  {
    key: "module:s",
    module: null,
    values: {
      en: "Modules",
      ru: "Модули",
      uk: "Модулі",
    },
  },
  {
    key: "settings",
    module: null,
    values: {
      en: "Settings",
      ru: "Настройки",
      uk: "Налаштування",
    },
  },
  {
    key: "formTitle",
    module: null,
    values: {
      en: "Dynamic Form Builder",
      ru: "Конструктор форм",
      uk: "Конструктор форм",
    },
  },
  {
    key: "tableTitle",
    module: null,
    values: {
      en: "Dynamic Table",
      ru: "Динамическая таблица",
      uk: "Динамічна таблиця",
    },
  },
  {
    key: "settingsTitle",
    module: null,
    values: {
      en: "Settings",
      ru: "Настройки",
      uk: "Налаштування",
    },
  },
  {
    key: "sidebar",
    module: null,
    values: {
      en: "Sidebar",
      ru: "Боковое меню",
      uk: "Бокове меню",
    },
  },
  {
    key: "dashboardTitle",
    module: null,
    values: {
      en: "Dashboard",
      ru: "Доска",
      uk: "Дошка",
    },
  },
  {
    key: "dashboard",
    module: null,
    values: {
      en: "Dashboard",
      ru: "Доска",
      uk: "Дошка",
    },
  },
  {
    key: "roles",
    module: null,
    values: {
      en: "Roles",
      ru: "Роли",
      uk: "Ролі",
    },
  },
  {
    key: "diagrams",
    module: null,
    values: {
      en: "Diagrams",
      ru: "Диаграммы",
      uk: "Діаграми",
    },
  },

  // BUTTONS & TOASTS
  {
    key: "save",
    module: null,
    values: {
      en: "Save",
      ru: "Сохранить",
      uk: "Зберегти",
    },
  },
  {
    key: "cancel",
    module: null,
    values: {
      en: "Cancel",
      ru: "Отмена",
      uk: "Скасувати",
    },
  },
  {
    key: "formSubmitted",
    module: null,
    values: {
      en: "Form submitted",
      ru: "Форма отправлена",
      uk: "Форму надіслано",
    },
  },
  {
    key: "settingsSaved",
    module: null,
    values: {
      en: "Settings saved!",
      ru: "Настройки сохранены!",
      uk: "Налаштування збережено!",
    },
  },
  {
    key: "settingsFailed",
    module: null,
    values: {
      en: "Failed to save settings.",
      ru: "Ошибка сохранения.",
      uk: "Помилка збереження.",
    },
  },

  // SETTINGS FIELDS
  {
    key: "applicationTheme",
    module: null,
    values: {
      en: "Application Theme",
      ru: "Тема приложения",
      uk: "Тема застосунку",
    },
  },
  {
    key: "fontSize",
    module: null,
    values: {
      en: "Font Size",
      ru: "Размер шрифта",
      uk: "Розмір шрифту",
    },
  },
  {
    key: "fontFamily",
    module: null,
    values: {
      en: "Font Family",
      ru: "Семейство шрифта",
      uk: "Сімейство шрифту",
    },
  },
  {
    key: "soundVolume",
    module: null,
    values: {
      en: "Sound Volume",
      ru: "Громкость звука",
      uk: "Гучність звуку",
    },
  },
  {
    key: "language",
    module: null,
    values: {
      en: "Language",
      ru: "Язык",
      uk: "Мова",
    },
  },
  {
    key: "iconStyle",
    module: null,
    values: {
      en: "Icon Style",
      ru: "Стиль иконок",
      uk: "Стиль іконок",
    },
  },
  {
    key: "chooseIcon",
    module: null,
    values: {
      en: "Choose Icon",
      ru: "Выбрать иконку",
      uk: "Обрати іконку",
    },
  },
  {
    key: "enableSoundNotifications",
    module: null,
    values: {
      en: "Enable Sound Notifications",
      ru: "Включить звуковые уведомления",
      uk: "Увімкнути звукові сповіщення",
    },
  },
  {
    key: "dateFormat",
    module: null,
    values: {
      en: "Date Format",
      ru: "Формат даты",
      uk: "Формат дати",
    },
  },
  {
    key: "timezone",
    module: null,
    values: {
      en: "Timezone",
      ru: "Часовой пояс",
      uk: "Часовий пояс",
    },
  },
  {
    key: "dateTimeSettings",
    module: null,
    values: {
      en: "Date & Time Settings",
      ru: "Настройки даты и времени",
      uk: "Налаштування дати та часу",
    },
  },

  // COLOR PALETTE
  {
    key: "chooseYourColor",
    module: null,
    values: {
      en: "Choose Your Color",
      ru: "Выберите свой цвет",
      uk: "Оберіть свій колір",
    },
  },
  {
    key: "light",
    module: null,
    values: {
      en: "Light",
      ru: "Светлая",
      uk: "Світла",
    },
  },
  {
    key: "dark",
    module: null,
    values: {
      en: "Dark",
      ru: "Тёмная",
      uk: "Темна",
    },
  },
  {
    key: "switchToLightMode",
    module: null,
    values: {
      en: "Switch to Light Mode",
      ru: "Переключить на светлый режим",
      uk: "Перемкнути на світлий режим",
    },
  },
  {
    key: "switchToDarkMode",
    module: null,
    values: {
      en: "Switch to Dark Mode",
      ru: "Переключить на тёмный режим",
      uk: "Перемкнути на темний режим",
    },
  },
  {
    key: "showPalette",
    module: null,
    values: {
      en: "Show Palette",
      ru: "Показать палитру",
      uk: "Показати палітру",
    },
  },
  {
    key: "hidePalette",
    module: null,
    values: {
      en: "Hide Palette",
      ru: "Скрыть палитру",
      uk: "Сховати палітру",
    },
  },

  // MISC UI
  {
    key: "logout",
    module: null,
    values: {
      en: "Logout",
      ru: "Выход",
      uk: "Вийти",
    },
  },
  {
    key: "menu",
    module: null,
    values: {
      en: "Menu",
      ru: "Меню",
      uk: "Меню",
    },
  },
  {
    key: "toggleSidebar",
    module: null,
    values: {
      en: "Toggle sidebar",
      ru: "Показать/скрыть панель",
      uk: "Перемкнути бічну панель",
    },
  },
  {
    key: "toggleMenu",
    module: null,
    values: {
      en: "Toggle menu",
      ru: "Открыть меню",
      uk: "Відкрити меню",
    },
  },
  {
    key: "dynamicFormBuilder",
    module: null,
    values: {
      en: "Dynamic Form Builder",
      ru: "Конструктор форм",
      uk: "Конструктор форм",
    },
  },
  {
    key: "home",
    module: null,
    values: {
      en: "Home",
      ru: "Главная",
      uk: "Головна",
    },
  },

  // LANGUAGE OPTIONS
  {
    key: "english",
    module: null,
    values: {
      en: "English",
      ru: "Английский",
      uk: "Англійська",
    },
  },
  {
    key: "russian",
    module: null,
    values: {
      en: "Russian",
      ru: "Русский",
      uk: "Російська",
    },
  },
  {
    key: "ukrainian",
    module: null,
    values: {
      en: "Ukrainian",
      ru: "Украинский",
      uk: "Українська",
    },
  },

  // FONT SIZE OPTIONS
  {
    key: "small",
    module: null,
    values: {
      en: "Small",
      ru: "Маленький",
      uk: "Малий",
    },
  },
  {
    key: "medium",
    module: null,
    values: {
      en: "Medium",
      ru: "Средний",
      uk: "Середній",
    },
  },
  {
    key: "large",
    module: null,
    values: {
      en: "Large",
      ru: "Большой",
      uk: "Великий",
    },
  },

  // TABLE PAGE
  {
    key: "addRow",
    module: null,
    values: {
      en: "Add row",
      ru: "Добавить строку",
      uk: "Додати рядок",
    },
  },
  {
    key: "deleteRow",
    module: null,
    values: {
      en: "Delete row",
      ru: "Удалить строку",
      uk: "Видалити рядок",
    },
  },
  {
    key: "editRow",
    module: null,
    values: {
      en: "Edit row",
      ru: "Редактировать строку",
      uk: "Редагувати рядок",
    },
  },
  {
    key: "saveRow",
    module: null,
    values: {
      en: "Save row",
      ru: "Сохранить строку",
      uk: "Зберегти рядок",
    },
  },
  {
    key: "noData",
    module: null,
    values: {
      en: "No data",
      ru: "Нет данных",
      uk: "Немає даних",
    },
  },
  {
    key: "rowsPerPage",
    module: null,
    values: {
      en: "Rows per page",
      ru: "Строк на странице",
      uk: "Рядків на сторінці",
    },
  },
  {
    key: "search",
    module: null,
    values: {
      en: "Search",
      ru: "Поиск",
      uk: "Пошук",
    },
  },
  {
    key: "actions",
    module: null,
    values: {
      en: "Actions",
      ru: "Действия",
      uk: "Дії",
    },
  },

  // FORM BUILDER
  {
    key: "addField",
    module: null,
    values: {
      en: "Add field",
      ru: "Добавить поле",
      uk: "Додати поле",
    },
  },
  {
    key: "deleteField",
    module: null,
    values: {
      en: "Delete field",
      ru: "Удалить поле",
      uk: "Видалити поле",
    },
  },
  {
    key: "editField",
    module: null,
    values: {
      en: "Edit field",
      ru: "Редактировать поле",
      uk: "Редагувати поле",
    },
  },
  {
    key: "fieldLabel",
    module: null,
    values: {
      en: "Field label",
      ru: "Название поля",
      uk: "Назва поля",
    },
  },
  {
    key: "fieldType",
    module: null,
    values: {
      en: "Field type",
      ru: "Тип поля",
      uk: "Тип поля",
    },
  },
  {
    key: "required",
    module: null,
    values: {
      en: "Required",
      ru: "Обязательное",
      uk: "Обов'язкове",
    },
  },
  {
    key: "optional",
    module: null,
    values: {
      en: "Optional",
      ru: "Необязательное",
      uk: "Необов'язкове",
    },
  },
  {
    key: "placeholder",
    module: null,
    values: {
      en: "Placeholder",
      ru: "Подсказка",
      uk: "Підказка",
    },
  },
  {
    key: "defaultValue",
    module: null,
    values: {
      en: "Default value",
      ru: "Значение по умолчанию",
      uk: "Значення за замовчуванням",
    },
  },

  // VALIDATION
  {
    key: "validation",
    module: null,
    values: {
      en: "Validation",
      ru: "Валидация",
      uk: "Валідація",
    },
  },
  {
    key: "requiredField",
    module: null,
    values: {
      en: "This field is required",
      ru: "Это поле обязательно",
      uk: "Це поле є обовʼязковим",
    },
  },
  {
    key: "invalidValue",
    module: null,
    values: {
      en: "Invalid value",
      ru: "Неверное значение",
      uk: "Некоректне значення",
    },
  },
  {
    key: "minLength",
    module: null,
    values: {
      en: "Minimum length",
      ru: "Минимальная длина",
      uk: "Мінімальна довжина",
    },
  },
  {
    key: "maxLength",
    module: null,
    values: {
      en: "Maximum length",
      ru: "Максимальная длина",
      uk: "Максимальна довжина",
    },
  },
  {
    key: "minValue",
    module: null,
    values: {
      en: "Minimum value",
      ru: "Минимальное значение",
      uk: "Мінімальне значення",
    },
  },
  {
    key: "maxValue",
    module: null,
    values: {
      en: "Maximum value",
      ru: "Максимальное значение",
      uk: "Максимальне значення",
    },
  },

  // DIAGRAM EDITOR
  {
    key: "diagramEditor",
    module: null,
    values: {
      en: "Diagram Editor",
      ru: "Редактор диаграмм",
      uk: "Редактор діаграм",
    },
  },
  {
    key: "addShape",
    module: null,
    values: {
      en: "Add shape",
      ru: "Добавить фигуру",
      uk: "Додати фігуру",
    },
  },
  {
    key: "deleteShape",
    module: null,
    values: {
      en: "Delete shape",
      ru: "Удалить фигуру",
      uk: "Видалити фігуру",
    },
  },
  {
    key: "connectShapes",
    module: null,
    values: {
      en: "Connect shapes",
      ru: "Соединить фигуры",
      uk: "Зʼєднати фігури",
    },
  },
  {
    key: "properties",
    module: null,
    values: {
      en: "Properties",
      ru: "Свойства",
      uk: "Властивості",
    },
  },
  {
    key: "text",
    module: null,
    values: {
      en: "Text",
      ru: "Текст",
      uk: "Текст",
    },
  },
  {
    key: "line",
    module: null,
    values: {
      en: "Line",
      ru: "Линия",
      uk: "Лінія",
    },
  },
  {
    key: "shape",
    module: null,
    values: {
      en: "Shape",
      ru: "Фигура",
      uk: "Фігура",
    },
  },
  {
    key: "delete",
    module: null,
    values: {
      en: "Delete",
      ru: "Удалить",
      uk: "Видалити",
    },
  },

  // HOTKEYS / HELP
  {
    key: "keyboardShortcuts",
    module: null,
    values: {
      en: "Keyboard Shortcuts",
      ru: "Горячие клавиши",
      uk: "Гарячі клавіші",
    },
  },
  {
    key: "help",
    module: null,
    values: {
      en: "Help",
      ru: "Справка",
      uk: "Довідка",
    },
  },
  {
    key: "openHelp",
    module: null,
    values: {
      en: "Open help",
      ru: "Открыть справку",
      uk: "Відкрити довідку",
    },
  },
  {
    key: "helpInfo",
    module: null,
    values: {
      en: "Keyboard shortcuts",
      ru: "Горячие клавиши",
      uk: "Гарячі клавіші",
    },
  },
  {
    key: "note",
    module: null,
    values: {
      en: "Note",
      ru: "Примечание",
      uk: "Примітка",
    },
  },
  {
    key: "hotkeyNote",
    module: null,
    values: {
      en: "Most hotkeys are disabled while editing cells to prevent conflicts.",
      ru: "Большинство горячих клавиш отключены при редактировании ячеек для предотвращения конфликтов.",
      uk: "Більшість гарячих клавіш вимкнені під час редагування комірок для уникнення конфліктів.",
    },
  },

  // CONFIRM / COMMON DIALOGS
  {
    key: "confirm",
    module: null,
    values: {
      en: "Confirm",
      ru: "Подтвердить",
      uk: "Підтвердити",
    },
  },
  {
    key: "confirmDelete",
    module: null,
    values: {
      en: "Are you sure?",
      ru: "Вы уверены?",
      uk: "Ви впевнені?",
    },
  },
  {
    key: "confirmDeleteRow",
    module: null,
    values: {
      en: "Delete row?",
      ru: "Удалить строку?",
      uk: "Видалити рядок?",
    },
  },
  {
    key: "confirmDeleteMessage",
    module: null,
    values: {
      en: "This action cannot be undone.",
      ru: "Это действие нельзя отменить.",
      uk: "Цю дію неможливо скасувати.",
    },
  },
  {
    key: "yes",
    module: null,
    values: {
      en: "Yes",
      ru: "Да",
      uk: "Так",
    },
  },
  {
    key: "no",
    module: null,
    values: {
      en: "No",
      ru: "Нет",
      uk: "Ні",
    },
  },
  {
    key: "close",
    module: null,
    values: {
      en: "Close",
      ru: "Закрыть",
      uk: "Закрити",
    },
  },
  {
    key: "back",
    module: null,
    values: {
      en: "Back",
      ru: "Назад",
      uk: "Назад",
    },
  },

  // ERRORS / VALIDATION
  {
    key: "error",
    module: null,
    values: {
      en: "Error",
      ru: "Ошибка",
      uk: "Помилка",
    },
  },
  {
    key: "fieldRequired",
    module: null,
    values: {
      en: "This field is required",
      ru: "Это поле обязательно",
      uk: "Це поле обов'язкове",
    },
  },
  {
    key: "tooShort",
    module: null,
    values: {
      en: "Too short",
      ru: "Слишком коротко",
      uk: "Занадто коротко",
    },
  },
  {
    key: "tooLong",
    module: null,
    values: {
      en: "Too long",
      ru: "Слишком длинно",
      uk: "Занадто довго",
    },
  },
  {
    key: "invalidEmail",
    module: null,
    values: {
      en: "Invalid email",
      ru: "Неверный email",
      uk: "Невірний email",
    },
  },
  {
    key: "invalidEmailFormat",
    module: null,
    values: {
      en: "Invalid email format",
      ru: "Неверный формат email",
      uk: "Невірний формат email",
    },
  },
  {
    key: "passwordsDontMatch",
    module: null,
    values: {
      en: "Passwords do not match",
      ru: "Пароли не совпадают",
      uk: "Паролі не співпадають",
    },
  },
  {
    key: "atLeast6",
    module: null,
    values: {
      en: "At least 6 characters",
      ru: "Минимум 6 символов",
      uk: "Мінімум 6 символів",
    },
  },

  // TABLE / PAGINATION
  {
    key: "rowsPerPage",
    module: null,
    values: {
      en: "Rows per page",
      ru: "Строк на странице",
      uk: "Рядків на сторінку",
    },
  },
  {
    key: "previousPage",
    module: null,
    values: {
      en: "Previous page",
      ru: "Предыдущая страница",
      uk: "Попередня сторінка",
    },
  },
  {
    key: "nextPage",
    module: null,
    values: {
      en: "Next page",
      ru: "Следующая страница",
      uk: "Наступна сторінка",
    },
  },
  {
    key: "firstPage",
    module: null,
    values: {
      en: "First page",
      ru: "Первая страница",
      uk: "Перша сторінка",
    },
  },
  {
    key: "lastPage",
    module: null,
    values: {
      en: "Last page",
      ru: "Последняя страница",
      uk: "Остання сторінка",
    },
  },
  {
    key: "goToPage",
    module: null,
    values: {
      en: "Go to page",
      ru: "Перейти на страницу",
      uk: "Перейти на сторінку",
    },
  },
  {
    key: "showing",
    module: null,
    values: {
      en: "Showing",
      ru: "Показано",
      uk: "Показано",
    },
  },
  {
    key: "of",
    module: null,
    values: {
      en: "of",
      ru: "из",
      uk: "з",
    },
  },
  {
    key: "entries",
    module: null,
    values: {
      en: "entries",
      ru: "записей",
      uk: "записів",
    },
  },

  // AUTH — LOGIN
  {
    key: "login",
    module: null,
    values: {
      en: "Login",
      ru: "Вход",
      uk: "Увійти",
    },
  },
  {
    key: "loginTitle",
    module: null,
    values: {
      en: "Sign in",
      ru: "Войти",
      uk: "Увійти",
    },
  },
  {
    key: "loginSuccess",
    module: null,
    values: {
      en: "Login successful!",
      ru: "Вход выполнен успешно!",
      uk: "Вхід успішний!",
    },
  },
  {
    key: "loginFailed",
    module: null,
    values: {
      en: "Login failed",
      ru: "Ошибка входа",
      uk: "Помилка входу",
    },
  },
  {
    key: "email",
    module: null,
    values: {
      en: "Email",
      ru: "Электронная почта",
      uk: "Електронна пошта",
    },
  },
  {
    key: "password",
    module: null,
    values: {
      en: "Password",
      ru: "Пароль",
      uk: "Пароль",
    },
  },
  {
    key: "forgotPassword",
    module: null,
    values: {
      en: "Forgot password?",
      ru: "Забыли пароль?",
      uk: "Забули пароль?",
    },
  },
  {
    key: "noAccount",
    module: null,
    values: {
      en: "No account? Sign up",
      ru: "Нет аккаунта? Зарегистрироваться",
      uk: "Немає акаунта? Зареєструватися",
    },
  },

  // AUTH — REGISTER
  {
    key: "registerTitle",
    module: null,
    values: {
      en: "Sign up",
      ru: "Регистрация",
      uk: "Реєстрація",
    },
  },
  {
    key: "registrationSuccess",
    module: null,
    values: {
      en: "Registration successful! Please log in.",
      ru: "Регистрация успешна! Пожалуйста, войдите.",
      uk: "Реєстрація успішна! Будь ласка, увійдіть.",
    },
  },
  {
    key: "alreadyHaveAccount",
    module: null,
    values: {
      en: "Already have an account? Log in",
      ru: "Уже есть аккаунт? Войти",
      uk: "Вже маєте акаунт? Увійти",
    },
  },

  // TELEGRAM ID
  {
    key: "enterTelegramId",
    module: null,
    values: {
      en: "Enter Telegram ID",
      ru: "Введите Telegram ID",
      uk: "Введіть Telegram ID",
    },
  },
  {
    key: "telegramIdHint",
    module: null,
    values: {
      en: "Get your ID from",
      ru: "Получите ваш ID у",
      uk: "Отримайте ваш ID у",
    },
  },
  {
    key: "telegramTgHint",
    module: null,
    values: {
      en: "Notifications via",
      ru: "Уведомления через",
      uk: "Сповіщення через",
    },
  },

  // FORGOT PASSWORD
  {
    key: "forgotTitle",
    module: null,
    values: {
      en: "Password Recovery",
      ru: "Восстановление пароля",
      uk: "Відновлення пароля",
    },
  },
  {
    key: "resetPassword",
    module: null,
    values: {
      en: "Reset Password",
      ru: "Сброс пароля",
      uk: "Скидання пароля",
    },
  },
  {
    key: "sendResetCode",
    module: null,
    values: {
      en: "Send Code",
      ru: "Отправить код",
      uk: "Надіслати код",
    },
  },
  {
    key: "resetCode",
    module: null,
    values: {
      en: "Recovery Code",
      ru: "Код восстановления",
      uk: "Код відновлення",
    },
  },
  {
    key: "enterResetCodeFromTelegram",
    module: null,
    values: {
      en: "Enter code from Telegram",
      ru: "Введите код из Telegram",
      uk: "Введіть код з Telegram",
    },
  },
  {
    key: "resetCodeSentToTelegram",
    module: null,
    values: {
      en: "Code sent to Telegram",
      ru: "Код отправлен в Telegram",
      uk: "Код надіслано в Telegram",
    },
  },
  {
    key: "passwordResetSuccessCheckTelegram",
    module: null,
    values: {
      en: "Password reset successful. New password sent to Telegram",
      ru: "Пароль успешно сброшен. Новый пароль отправлен в Telegram",
      uk: "Пароль успішно скинуто. Новий пароль надіслано в Telegram",
    },
  },
  {
    key: "resetRequestFailed",
    module: null,
    values: {
      en: "Failed to send code",
      ru: "Не удалось отправить код",
      uk: "Не вдалося надіслати код",
    },
  },
  {
    key: "passwordResetFailed",
    module: null,
    values: {
      en: "Failed to reset password",
      ru: "Не удалось сбросить пароль",
      uk: "Не вдалося скинути пароль",
    },
  },
  {
    key: "back",
    module: null,
    values: {
      en: "Back",
      ru: "Назад",
      uk: "Назад",
    },
  },

  // FORM PLACEHOLDERS
  {
    key: "enterName",
    module: null,
    values: {
      en: "Enter your name",
      ru: "Введите ваше имя",
      uk: "Введіть ваше ім'я",
    },
  },
  {
    key: "enterEmail",
    module: null,
    values: {
      en: "Enter your email",
      ru: "Введите email",
      uk: "Введіть email",
    },
  },
  {
    key: "enterPassword",
    module: null,
    values: {
      en: "Enter your password",
      ru: "Введите пароль",
      uk: "Введіть пароль",
    },
  },
  {
    key: "enterCountry",
    module: null,
    values: {
      en: "Enter your country",
      ru: "Введите страну",
      uk: "Введіть країну",
    },
  },
  {
    key: "enterCity",
    module: null,
    values: {
      en: "Enter your city",
      ru: "Введите город",
      uk: "Введіть місто",
    },
  },
  {
    key: "enterAddress",
    module: null,
    values: {
      en: "Enter your address",
      ru: "Введите адрес",
      uk: "Введіть адресу",
    },
  },
  {
    key: "selectCountry",
    module: null,
    values: {
      en: "Select a country",
      ru: "Выберите страну",
      uk: "Оберіть країну",
    },
  },
  {
    key: "selectLanguage",
    module: null,
    values: {
      en: "Select a language",
      ru: "Выберите язык",
      uk: "Оберіть мову",
    },
  },
  {
    key: "writeMessage",
    module: null,
    values: {
      en: "Write your message...",
      ru: "Введите сообщение...",
      uk: "Введіть повідомлення...",
    },
  },

  // FORM FIELDS
  {
    key: "username",
    module: null,
    values: {
      en: "Username",
      ru: "Имя пользователя",
      uk: "Ім'я користувача",
    },
  },
  {
    key: "email",
    module: null,
    values: {
      en: "Email",
      ru: "Электронная почта",
      uk: "Електронна пошта",
    },
  },
  {
    key: "bio",
    module: null,
    values: {
      en: "Bio",
      ru: "Биография",
      uk: "Біографія",
    },
  },
  {
    key: "birthDate",
    module: null,
    values: {
      en: "Birth Date",
      ru: "Дата рождения",
      uk: "Дата народження",
    },
  },
  {
    key: "country",
    module: null,
    values: {
      en: "Country",
      ru: "Страна",
      uk: "Країна",
    },
  },
  {
    key: "skills",
    module: null,
    values: {
      en: "Skills",
      ru: "Навыки",
      uk: "Навички",
    },
  },
  {
    key: "saving",
    module: null,
    values: {
      en: "Saving...",
      ru: "Сохранение...",
      uk: "Збереження...",
    },
  },
  {
    key: "dataSavedSuccessfully",
    module: null,
    values: {
      en: "Data saved successfully!",
      ru: "Данные успешно сохранены!",
      uk: "Дані успішно збережено!",
    },
  },
  {
    key: "errorSavingData",
    module: null,
    values: {
      en: "Error saving data",
      ru: "Ошибка сохранения данных",
      uk: "Помилка збереження даних",
    },
  },

  // FILE VALIDATION
  {
    key: "maxFileSize",
    module: null,
    values: {
      en: "Max file size",
      ru: "Макс. размер файла",
      uk: "Макс. розмір файлу",
    },
  },
  {
    key: "fileTooLarge",
    module: null,
    values: {
      en: "File size exceeds {size}MB",
      ru: "Размер файла превышает {size}МБ",
      uk: "Розмір файлу перевищує {size}МБ",
    },
  },
  {
    key: "invalidFileFormat",
    module: null,
    values: {
      en: "Invalid format. Allowed: {formats}",
      ru: "Неверный формат. Разрешены: {formats}",
      uk: "Невірний формат. Дозволені: {formats}",
    },
  },
  {
    key: "invalidFileExtension",
    module: null,
    values: {
      en: "Invalid file extension. Allowed: {formats}",
      ru: "Неверное расширение файла. Разрешены: {formats}",
      uk: "Невірне розширення файлу. Дозволені: {formats}",
    },
  },
  {
    key: "errorReadingFile",
    module: null,
    values: {
      en: "Error reading file",
      ru: "Ошибка чтения файла",
      uk: "Помилка читання файлу",
    },
  },
  {
    key: "changeFile",
    module: null,
    values: {
      en: "Change file",
      ru: "Изменить файл",
      uk: "Змінити файл",
    },
  },

  // HOTKEYS
  {
    key: "keyboardShortcuts",
    module: null,
    values: {
      en: "Keyboard Shortcuts",
      ru: "Горячие клавиши",
      uk: "Гарячі клавіші",
    },
  },
  {
    key: "help",
    module: null,
    values: {
      en: "Help",
      ru: "Справка",
      uk: "Довідка",
    },
  },
  {
    key: "saveAction",
    module: null,
    values: {
      en: "Save",
      ru: "Сохранить",
      uk: "Зберегти",
    },
  },
  {
    key: "newRow",
    module: null,
    values: {
      en: "New Row",
      ru: "Новая строка",
      uk: "Новий рядок",
    },
  },
  {
    key: "deleteRow",
    module: null,
    values: {
      en: "Delete Selected Row",
      ru: "Удалить выбранную строку",
      uk: "Видалити вибраний рядок",
    },
  },
  {
    key: "editSelectedRow",
    module: null,
    values: {
      en: "Edit selected row",
      ru: "Редактировать выбранную строку",
      uk: "Редагувати вибраний рядок",
    },
  },
  {
    key: "saveAllChanges",
    module: null,
    values: {
      en: "Save all changes",
      ru: "Сохранить все изменения",
      uk: "Зберегти всі зміни",
    },
  },
  {
    key: "cancelEdit",
    module: null,
    values: {
      en: "Cancel edit",
      ru: "Отменить редактирование",
      uk: "Скасувати редагування",
    },
  },
  {
    key: "openHelp",
    module: null,
    values: {
      en: "Open help",
      ru: "Открыть справку",
      uk: "Відкрити довідку",
    },
  },

  // DASHBOARD / MODULES
  {
    key: "dashboard",
    module: null,
    values: {
      en: "Dashboard",
      ru: "Доска",
      uk: "Дошка",
    },
  },
  {
    key: "dashboardTitle",
    module: null,
    values: {
      en: "Dashboard",
      ru: "Доска",
      uk: "Дошка",
    },
  },
  {
    key: "welcomeMessage",
    module: null,
    values: {
      en: "Welcome! Please select a module: to continue working with:",
      ru: "Здравствуйте! Выберите модуль для дальнейшей работы:",
      uk: "Вітаємо! Оберіть модуль для подальшої роботи:",
    },
  },
  {
    key: "systemModules",
    module: null,
    values: {
      en: "System Modules",
      ru: "Системные модули",
      uk: "Системні модулі",
    },
  },
  {
    key: "reports",
    module: null,
    values: {
      en: "Reports",
      ru: "Отчеты",
      uk: "Звіти",
    },
  },
  {
    key: "arrangeSystemModules",
    module: null,
    values: {
      en: "Arrange System Modules",
      ru: "Расположите системные модули",
      uk: "Розташуйте системні модулі",
    },
  },
  {
    key: "arrangeReports",
    module: null,
    values: {
      en: "Arrange Reports",
      ru: "Расположите отчеты",
      uk: "Розташуйте звіти",
    },
  },
  {
    key: "noAccess",
    module: null,
    values: {
      en: "Access Denied",
      ru: "Доступ запрещен",
      uk: "Доступ заборонено",
    },
  },
  {
    key: "arrangeModules",
    module: null,
    values: {
      en: "Arrange Modules",
      ru: "Расположение модулей",
      uk: "Розташування модулів",
    },
  },

  // DIAGRAM EDITOR
  {
    key: "diagramEditor",
    module: null,
    values: {
      en: "Diagram Editor",
      ru: "Редактор диаграмм",
      uk: "Редактор діаграм",
    },
  },
  {
    key: "shapes",
    module: null,
    values: {
      en: "Shapes",
      ru: "Фигуры",
      uk: "Фігури",
    },
  },
  {
    key: "elements",
    module: null,
    values: {
      en: "Elements",
      ru: "Элементы",
      uk: "Елементи",
    },
  },
  {
    key: "zoomIn",
    module: null,
    values: {
      en: "Zoom In",
      ru: "Увеличить",
      uk: "Збільшити",
    },
  },
  {
    key: "zoomOut",
    module: null,
    values: {
      en: "Zoom Out",
      ru: "Уменьшить",
      uk: "Зменшити",
    },
  },
  {
    key: "resetZoom",
    module: null,
    values: {
      en: "Reset Zoom",
      ru: "Сбросить масштаб",
      uk: "Скинути масштаб",
    },
  },
  {
    key: "rectangle",
    module: null,
    values: {
      en: "Rectangle",
      ru: "Прямоугольник",
      uk: "Прямокутник",
    },
  },
  {
    key: "circle",
    module: null,
    values: {
      en: "Circle",
      ru: "Круг",
      uk: "Коло",
    },
  },
  {
    key: "text",
    module: null,
    values: {
      en: "Text",
      ru: "Текст",
      uk: "Текст",
    },
  },
  {
    key: "line",
    module: null,
    values: {
      en: "Line",
      ru: "Линия",
      uk: "Лінія",
    },
  },
  {
    key: "deleteAllElements",
    module: null,
    values: {
      en: "Delete all elements?",
      ru: "Удалить все элементы?",
      uk: "Видалити всі елементи?",
    },
  },
  {
    key: "editMode",
    module: null,
    values: {
      en: "Edit Mode",
      ru: "Режим редактирования",
      uk: "Режим редагування",
    },
  },
  {
    key: "viewMode",
    module: null,
    values: {
      en: "View Mode",
      ru: "Режим просмотра",
      uk: "Режим перегляду",
    },
  },

  // ROLES / PERMISSIONS
  {
    key: "roles",
    module: null,
    values: {
      en: "Roles",
      ru: "Роли",
      uk: "Ролі",
    },
  },
  {
    key: "rolesManagement",
    module: null,
    values: {
      en: "Roles Management",
      ru: "Управление ролями",
      uk: "Управління ролями",
    },
  },
  {
    key: "arrangeRoles",
    module: null,
    values: {
      en: "Arrange Roles",
      ru: "Расположение ролей",
      uk: "Розташування ролей",
    },
  },
  {
    key: "rolesModuleNotFound",
    module: null,
    values: {
      en: "Roles module: not found",
      ru: "Модуль ролей не найден",
      uk: "Модуль ролей не знайдено",
    },
  },
  {
    key: "editRole",
    module: null,
    values: {
      en: "Edit Role",
      ru: "Редактировать роль",
      uk: "Редагувати роль",
    },
  },
  {
    key: "manageRolePermissions",
    module: null,
    values: {
      en: "Manage role permissions",
      ru: "Управление правами доступа",
      uk: "Керування правами доступу",
    },
  },
  {
    key: "fullAccess",
    module: null,
    values: {
      en: "Full Access",
      ru: "Полный доступ",
      uk: "Повний доступ",
    },
  },
  {
    key: "read",
    module: null,
    values: {
      en: "Read",
      ru: "Чтение",
      uk: "Читання",
    },
  },
  {
    key: "update",
    module: null,
    values: {
      en: "Update",
      ru: "Редактирование",
      uk: "Редагування",
    },
  },
  {
    key: "enabled",
    module: null,
    values: {
      en: "Enabled",
      ru: "Включено",
      uk: "Увімкнено",
    },
  },
  {
    key: "disabled",
    module: null,
    values: {
      en: "Disabled",
      ru: "Выключено",
      uk: "Вимкнено",
    },
  },
  {
    key: "permissionsSaved",
    module: null,
    values: {
      en: "Permissions saved successfully!",
      ru: "Права доступа сохранены!",
      uk: "Права доступу збережено!",
    },
  },
  {
    key: "errorLoadingRole",
    module: null,
    values: {
      en: "Error loading role",
      ru: "Ошибка загрузки роли",
      uk: "Помилка завантаження ролі",
    },
  },

  // ROLES / PERMISSIONS
  {
    key: "roles",
    module: null,
    values: {
      en: "Roles",
      ru: "Роли",
      uk: "Ролі",
    },
  },
  {
    key: "rolesManagement",
    module: null,
    values: {
      en: "Roles Management",
      ru: "Управление ролями",
      uk: "Управління ролями",
    },
  },
  {
    key: "arrangeRoles",
    module: null,
    values: {
      en: "Arrange Roles",
      ru: "Расположение ролей",
      uk: "Розташування ролей",
    },
  },
  {
    key: "rolesModuleNotFound",
    module: null,
    values: {
      en: "Roles module: not found",
      ru: "Модуль ролей не найден",
      uk: "Модуль ролей не знайдено",
    },
  },
  {
    key: "editRole",
    module: null,
    values: {
      en: "Edit Role",
      ru: "Редактировать роль",
      uk: "Редагувати роль",
    },
  },
  {
    key: "manageRolePermissions",
    module: null,
    values: {
      en: "Manage role permissions",
      ru: "Управление правами доступа",
      uk: "Керування правами доступу",
    },
  },
  {
    key: "fullAccess",
    module: null,
    values: {
      en: "Full Access",
      ru: "Полный доступ",
      uk: "Повний доступ",
    },
  },
  {
    key: "read",
    module: null,
    values: {
      en: "Read",
      ru: "Чтение",
      uk: "Читання",
    },
  },
  {
    key: "update",
    module: null,
    values: {
      en: "Update",
      ru: "Редактирование",
      uk: "Редагування",
    },
  },
  {
    key: "enabled",
    module: null,
    values: {
      en: "Enabled",
      ru: "Включено",
      uk: "Увімкнено",
    },
  },
  {
    key: "disabled",
    module: null,
    values: {
      en: "Disabled",
      ru: "Выключено",
      uk: "Вимкнено",
    },
  },
  {
    key: "permissionsSaved",
    module: null,
    values: {
      en: "Permissions saved successfully!",
      ru: "Права доступа сохранены!",
      uk: "Права доступу збережено!",
    },
  },
  {
    key: "errorLoadingRole",
    module: null,
    values: {
      en: "Error loading role",
      ru: "Ошибка загрузки роли",
      uk: "Помилка завантаження ролі",
    },
  },

  // FIELD TYPES — OTHER
  {
    key: "bigintLabel",
    module: null,
    values: {
      en: "Big Number",
      ru: "Большое число",
      uk: "Велике число",
    },
  },
  {
    key: "bigintDesc",
    module: null,
    values: {
      en: "Very long integer values.",
      ru: "Очень длинные целые значения.",
      uk: "Дуже довгі цілі значення.",
    },
  },
  {
    key: "bigintExample",
    module: null,
    values: {
      en: "Example: 987654321012345678",
      ru: "Пример: 987654321012345678",
      uk: "Приклад: 987654321012345678",
    },
  },

  {
    key: "booleanLabel",
    module: null,
    values: {
      en: "Yes / No",
      ru: "Да / Нет",
      uk: "Так / Ні",
    },
  },
  {
    key: "booleanDesc",
    module: null,
    values: {
      en: "Binary value: enabled / disabled, active / inactive.",
      ru: "Логическое значение: включено / выключено, активно / неактивно.",
      uk: "Логічне значення: увімкнено / вимкнено, активно / неактивно.",
    },
  },
  {
    key: "booleanExample",
    module: null,
    values: {
      en: "Example: true / false (active: Yes)",
      ru: "Пример: true / false (активно: Да)",
      uk: "Приклад: true / false (активно: Так)",
    },
  },

  {
    key: "dateLabel",
    module: null,
    values: {
      en: "Date",
      ru: "Дата",
      uk: "Дата",
    },
  },
  {
    key: "dateDesc",
    module: null,
    values: {
      en: "Calendar date without time.",
      ru: "Календарная дата без времени.",
      uk: "Календарна дата без часу.",
    },
  },
  {
    key: "dateExample",
    module: null,
    values: {
      en: "Example: 2025-12-05",
      ru: "Пример: 2025-12-05",
      uk: "Приклад: 2025-12-05",
    },
  },

  {
    key: "datetimeLabel",
    module: null,
    values: {
      en: "Date & Time",
      ru: "Дата и время",
      uk: "Дата і час",
    },
  },
  {
    key: "datetimeDesc",
    module: null,
    values: {
      en: "Stores both date and time.",
      ru: "Сохраняет дату вместе со временем.",
      uk: "Зберігає дату разом із часом.",
    },
  },
  {
    key: "datetimeExample",
    module: null,
    values: {
      en: "Example: 2025-12-05 14:33",
      ru: "Пример: 2025-12-05 14:33",
      uk: "Приклад: 2025-12-05 14:33",
    },
  },

  {
    key: "fkLabel",
    module: null,
    values: {
      en: "Relation (Foreign Key)",
      ru: "Связь (Foreign Key)",
      uk: "Звʼязок (Foreign Key)",
    },
  },
  {
    key: "fkDesc",
    module: null,
    values: {
      en: "Stores ID of another record.",
      ru: "Хранит ID другой записи.",
      uk: "Зберігає ID іншого запису.",
    },
  },
  {
    key: "fkExample",
    module: null,
    values: {
      en: 'Example: user_id = 27 → table "users"',
      ru: 'Пример: user_id = 27 → таблица "users"',
      uk: 'Приклад: user_id = 27 → таблиця "users"',
    },
  },

  {
    key: "fileLabel",
    module: null,
    values: {
      en: "File",
      ru: "Файл",
      uk: "Файл",
    },
  },
  {
    key: "fileDesc",
    module: null,
    values: {
      en: "Upload document, image or any attachment.",
      ru: "Загрузка документа, изображения или вложения.",
      uk: "Завантаження документа, зображення або вкладення.",
    },
  },
  {
    key: "fileExample",
    module: null,
    values: {
      en: "Example: scan.pdf, avatar.png, document.docx",
      ru: "Пример: scan.pdf, avatar.png, document.docx",
      uk: "Приклад: scan.pdf, avatar.png, document.docx",
    },
  },

  {
    key: "multiselectLabel",
    module: null,
    values: {
      en: "Multi Select",
      ru: "Множественный выбор",
      uk: "Множинний вибір",
    },
  },
  {
    key: "multiselectDesc",
    module: null,
    values: {
      en: "Array of values: list of skills, tags or categories.",
      ru: "Массив значений: навыки, теги, категории.",
      uk: "Масив значень: навички, теги, категорії.",
    },
  },
  {
    key: "multiselectExample",
    module: null,
    values: {
      en: 'Example: ["TypeScript", "React", "CSS"]',
      ru: 'Пример: ["TypeScript", "React", "CSS"]',
      uk: 'Приклад: ["TypeScript", "React", "CSS"]',
    },
  },

  {
    key: "jsonLabel",
    module: null,
    values: {
      en: "JSON",
      ru: "JSON",
      uk: "JSON",
    },
  },
  {
    key: "jsonDesc",
    module: null,
    values: {
      en: "Flexible structure for storing complex data.",
      ru: "Гибкая структура для хранения сложных данных.",
      uk: "Гнучка структура для зберігання складних даних.",
    },
  },
  {
    key: "jsonExample",
    module: null,
    values: {
      en: 'Example: { "width": 120, "height": 80 }',
      ru: 'Пример: { "width": 120, "height": 80 }',
      uk: 'Приклад: { "width": 120, "height": 80 }',
    },
  },

  {
    key: "autoGenerated",
    module: null,
    values: {
      en: "Auto Generated",
      ru: "Сгенерировано автоматически",
      uk: "Автоматично згенеровано",
    },
  },
];
